import React, {
  useEffect,
  useState,
  useDeferredValue,
  useMemo,
  useRef,
} from "react";
import ArrowButton from "../../components/ArrowButton";
import FamilyCardJs from "../../components/FamilyCard.js/index.js";
import { useLocation, useNavigate } from "react-router";
import InputSearch from "../../components/InputSearch";
import AToZ from "../../components/AToZ";
import { Observer, observer } from "mobx-react";
import {
  getBlobToBase64,
  getDecodedToken,
  getOffshoreData,
  logout,
} from "../../utils/functions";
import Header from "../../components/Header/Header";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import SettingsStore from "../../store/SettingsStore";
import PerformanceStore from "../../store/PerformanceStore";
import ProfileStore2 from "../../store/ProfileStore2";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import ReportsStore from "../../store/ReportsStore";
import noFamilyFound from "../../assets/images/svg/nofamilyfound.svg";
import { setCookie } from "../../utils/cookie";
import { defaultSecondaryRMData, OFFSHORE } from "../../utils/constants.js";
import PageHeading from "../../components/PageHeading/PageHeading";
const LinkedClients = observer(() => {
  const [search, setSearch] = useState("");
  const defsearch = useDeferredValue(search);
  const [isSort, setSort] = useState("asc");
  const [isSorting, setIsSorting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [selectedMember, setSelectedMember] = useState(undefined);
  const [showErrorMsg, setShowErrorMsg] = useState(false);

  const parentScroll = useRef(null);
  const searchInputRef = useRef(null);

  const announce = (msg) => {
    const el = document.getElementById("aria-live-region");
    if (el) {
      // el.textContent = "";
      setTimeout(() => {
        el.textContent = !el.textContent ? msg : "";
      }, 0);
    }
  };
  const sortedArray = useMemo(() => {
    let sortedData = UserStore.linkedClients;
    if (sortedData && isSort === "asc") {
      sortedData = [...sortedData]?.sort();
    } else if (sortedData && isSort === "desc") {
      sortedData = [...sortedData]?.sort((a, b) =>
        b.family_name.localeCompare(a.family_name),
      );
    }
    setIsSorting(false);
    return sortedData;
    // eslint-disable-next-line
  }, [isSort, UserStore.linkedClients]);

  const familyArray = sortedArray?.filter((family) => {
    return (
      family.family_name.toLowerCase().includes(defsearch.toLowerCase()) ||
      family.memberList.some((e) => {
        return e.full_name.toLowerCase().includes(defsearch.toLowerCase());
      })
    );
  });

  const handleScrollStart = (e) => {
    const scrollTop = parentScroll.current.scrollTop;
    if (scrollTop >= 1) {
      searchInputRef?.current?.blur();
    }

    // if (
    //   e.target.clientHeight + e.target.scrollTop + 2 > e.target.scrollHeight &&
    //   showFamilyData?.length
    // ) {
    //   if (vertualRows) {
    //     setVertualRows((prev) => {
    //       if (prev) {
    //         return [
    //           ...prev,
    //           ...showFamilyData?.slice(prev?.length, prev?.length + 10),
    //         ];
    //       }
    //     });
    //   }
    // }
  };

  useEffect(() => {
    window.onpopstate = () => {
      if (location.pathname === "/linkedclients") {
        if (location?.state.from === "switchFamily") {
          const { isOffshoreOnly, navigateTo } = getOffshoreData();

          navigate(navigateTo, {
            state: isOffshoreOnly ? { from: OFFSHORE } : {},
          });
          //navigate("/home");
        } else if (
          location?.state.from === "loginPage" &&
          AuthStore.isfirstTimeFamilySelected === false
        ) {
          logout();
          navigate("/login/family-office-team");
        }
      }
    };
    // eslint-disable-next-line
  }, [location.pathname, navigate]);

  const handleChange = (e) => {
    setSearch((prevState) => e.target.value);
  };

  useEffect(() => {
    if (getDecodedToken()?.user_type !== "manager") {
    }
  }, []);

  useEffect(() => {
    if (getDecodedToken()?.user_type === "manager") {
      setLoading(true);
      UserStore._getLiaisionLinkedClients({
        onSuccess: (data) => {
          setLoading(false);
          const imageArr = {};
          if (!data.familiesList.length) {
            navigate("/nolinkedclients");
            AuthStore.updateLoadingForLogin(false);
          } else {
            navigate("/linkedclients", {
              state: {
                from: location.state?.from,
                pathname: location.state?.pathname,
              },
            });
            AuthStore.updateLoadingForLogin(false);
            data.familiesList.forEach((eachFamily) => {
              eachFamily.memberList.forEach((eachClient) => {
                if (eachClient.profile_pic) {
                  SettingsStore.getImageFromAPI({
                    path: eachClient.profile_pic,
                    onSuccess: (imageBlob) => {
                      getBlobToBase64(imageBlob).then((url) => {
                        let resImage = url;
                        imageArr[eachClient.user_id] = resImage;
                        AuthStore.updateSelectFamiliesPageAllImages(imageArr);
                      });
                    },
                  });
                }
              });
            });
            UserStore.setLinkedClients(data.familiesList);
          }
        },
        onFail: (error) => {
          setLoading(false);
        },
      });
      if (1) {
      }
      if (1) {
      }
      if (document.getElementById("cards")?.scrollHeight > 585) {
      }
    }
    // eslint-disable-next-line
  }, []);

  function onConfirm(data = selectedMember) {
    UserStore.setUserData({ allMembers: false });
    UserStore.setUserData(data, "whileLogginIn");
    UserStore.setSelectedClientId(data.user_id);
    ReportsStore.updatePortfolioReportFilterData(data, "mod3");
    ReportsStore.updateTransactionFilterData(data, "check2");
    ReportsStore.updateCorporateFilterData(data);

    UserStore.setClientOrFamily("client");
    setCookie("name", UserStore.userData?.full_name);
    PerformanceStore.setFamOrClient({
      name: "client",
      id: data.user_id,
    });
    UserStore.setConnectData([]);
    UserStore.setUserStoreData("secondaryRMDetails", defaultSecondaryRMData);
    if (data?.isheldaway === false && data?.investmentHeldWith === "2") {
      //  SettingsStore.callInvestmentsHeldWith("1");
    }
    ProfileStore2.getImage(
      UserStore.userData?.profile_pic ? UserStore.userData?.profile_pic : "",
      "normal",
    );
    setCookie("showpopup", "1");
    const { isOffshoreOnly, navigateTo } = getOffshoreData();

    navigate(navigateTo, {
      state: isOffshoreOnly ? { from: OFFSHORE } : {},
    });
    //navigate("/home");
    setTimeout(() => {
      announce("Loading Home page");
    }, 50);
    AuthStore.updateIsfirstTimeFamilySelected(true);
  }

  const checkUserToContinue = (userData) => {
    setShowErrorMsg(false);
    AuthStore.getHealthCheckData(
      userData.user_id,
      (data) => {
        if (data?.[0] && data?.[0]?.data === "0") {
          setSelectedMember(userData);
        } else {
          setShowErrorMsg(true);
          //   setCookie("showpopup", "0");
        }
      },
      (error) => {},
      "liaison",
    );
  };

  useEffect(() => {
    if (showErrorMsg) {
      setTimeout(() => {
        setShowErrorMsg(false);
      }, 7000);
    }
  }, [showErrorMsg]);

  return (
    <Observer>
      {() =>
        UserStore.isHydrated && !loading ? (
          <>
            <Header isLogoNavigationEnabled={false} />

            <div className="outer_main_div2">
              <div id="main_div" className="main_contaier_div2">
                <div
                  className={`health_Check_msg ${
                    showErrorMsg ? "msg_visible" : "msg_not_visible"
                  }`}
                >
                  Website is unavailable at the moment since we are updating
                  your portfolio. An email notification will be sent to you once
                  the updation is completed
                </div>
                <PageHeading
                  headingClass="families_title2"
                  headingText="Linked Clients"
                />
                <div className="families_liaison2">
                  You are currently linked to {UserStore.linkedClients?.length}{" "}
                  {UserStore.linkedClients?.length > 1 ? "Families" : "Family"}
                </div>
                <div
                  id="scoll"
                  ref={parentScroll}
                  className="select_families_scrollable"
                  onScroll={handleScrollStart}
                >
                  <div className="select_families_seach_atoz_wrapper">
                    <div className="search_family2">
                      <InputSearch
                        width={"520px"}
                        name="search"
                        value={search}
                        handleChange={handleChange}
                        setSearch={setSearch}
                        paddingRight={"21.03px"}
                        paddingLeft={"20px"}
                        searchInputRef={searchInputRef}
                        ref={searchInputRef}
                      />
                    </div>
                    <div
                      onClick={() => {
                        switch (isSort) {
                          case "asc":
                            setSort("desc");
                            break;
                          case "desc":
                            setSort("asc");
                            break;
                          default:
                            setSort("desc");
                            break;
                        }
                      }}
                      className="filter_family2"
                    >
                      <AToZ isSorting={isSorting} isSort={isSort} />
                    </div>
                  </div>
                  {familyArray?.length ? (
                    <div id="cards" className="families_cards2">
                      <>
                        {familyArray?.map((family, index, array) => (
                          <FamilyCardJs
                            setStart={() => {}}
                            onSelect={(data) => {
                              if (data.user_id === selectedMember?.user_id)
                                onConfirm();
                              else {
                                checkUserToContinue(data);
                              }
                            }}
                            getFamilyMemberImageFrom={
                              AuthStore.selectFamiliesPageAllImages
                            }
                            familyId={family.family_id}
                            key={family.family_id}
                            familyDetails={family}
                            ind={index}
                            len={array.length}
                            selectedFamily={String(selectedMember?.family_id)}
                            selectedUser={selectedMember?.user_id}
                          />
                        ))}
                      </>
                    </div>
                  ) : (
                    <div className="family_not_foundliason">
                      <img src={noFamilyFound} alt="no family found" />
                      <p className="not_found_heading">Family Name not found</p>
                      <p className="not_found_text">
                        The name {defsearch} did not match any Family member
                      </p>
                    </div>
                  )}
                </div>
                {familyArray?.length ? (
                  <div id="buttons" className="buttons_container2">
                    <ArrowButton
                      type="previous"
                      label="Go Back"
                      onClick={() => {
                        if (location?.state.from === "switchFamily") {
                          if (location?.state?.path)
                            navigate(location.state.path);
                          else {
                            const { isOffshoreOnly, navigateTo } =
                              getOffshoreData();

                            navigate(navigateTo, {
                              state: isOffshoreOnly ? { from: OFFSHORE } : {},
                            });
                            //navigate("/home");
                          }
                        } else {
                          logout();
                          navigate("/login/family-office-team");
                        }
                      }}
                    />{" "}
                    <ArrowButton
                      type="next"
                      label="Continue"
                      styleProp={{
                        cursor: selectedMember?.user_id
                          ? "pointer"
                          : "not-allowed",
                      }}
                      disabled={!selectedMember?.user_id}
                      onClick={() => onConfirm()}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        ) : (
          <LoadingScreen />
        )
      }
    </Observer>
  );
});

export default LinkedClients;
